import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Icon,
  Input,
  Modal,
  Drawer,
  notification,
  Row,
  Select,
  Table,
  Tooltip
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { PureComponent } from 'react'

import { connect } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { getPushPathWrapper, getUrlParams } from '../../../routes'

import { Editor } from 'react-draft-wysiwyg'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {
  ArticleTypeList,
  chooseEmailModalFxn,
  Countries,
  CustomCkEditor,
  DesignationList,
  InputBox,
  mentionsFeeds,
  NotificationBox,
  ProcessList, YearArr, YearArr2, paymentModeList, copiesList
} from '../../../components/_utils/appUtils'
import { CountriesList, JournalList } from '../../journals/actions'
import { singleOnlineSubmission } from '../../onlineSubmission/actions'
import { addMember, checkMemberEmails } from '../../members/actions'
import { addSubscriptionActivityFxn } from '../action'
import { getGroupedSubscription, journalsAjaxList } from '../../subscription/actions'

@Form.create()
class AddGeneralSubscriptionDrawer extends PureComponent {
  state = {
    name: '',
    journalListArr: [],
    email: '',
    state: '',
    journals: [],
    country: '',
    city: '',
    subscribedBy: '',
    yearOptions: [],
    pincode: '',
    pageNumber: '',
    endUserAddress: '',
    copies: '',
    designation: '',
    contactPerson: '',
    agencyName: '',
    subscriptionData: {},
    journalList: []
  }
  paymentDetails = {
    receivedDate: '',
    modeOfPayment: '',
    amount: '',
    year: []

  }

  constructor(props) {
    super(props)
    console.log(props.visible, 'sdddddds')
  }

  resetFormData = () => {
    const { dispatch, form } = this.props
    form.setFieldsValue({
      journals: [],
      name: '',
      email: '',
      country: '',
      state: '',
      city: '',
      pincode: '',
      subscribeBy: '',
      address: '',
      mobile: '',
      instituteName: '',
      instituteContactPerson: '',
      instituteContactNo: '',
      instituteAddress: '',
      copies: ''
    })
  }
  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {

        console.log(this.state, 'totalAmounttotalAmounttotalAmount')

        valData.totalAmount = this.state.totalAmount
        valData.amountDetails = this.state.amountDetails
        let { success, message } = await dispatch(addSubscriptionActivityFxn(valData))

        if (success) {
          notification.success({
            message: message
          })
          this.resetFormData()
          this.props.onClose()
          this.setState({
            name: '',
            email: '',
            country: '',
            state: '',
            city: '',
            pincode: '',
            subscriptionBy: '',
            journals: '',
            pageNumber: '',
            endUserAddress: '',
            designation: '',
            contactPerson: '',
            agencyName: '',
            copies: ''
          })
        }
      }
    })

  }


  componentDidMount() {
    this.loadJournalList()
    this.apiGroupedSubscription()
    this.journalAjax()
    let data = getUrlParams('article.onlineSubmission', this.props.pathname)
    if (!!data) {
      let { id } = data
      this.setFormValuesFxn(id)
    }
  }

  calculateTotalAmount = (selectedJournals, selectedYears, copiesCount) => {
    const { subscriptionData } = this.state
    let total = 0
    const amountDetails = []

    if (!selectedJournals || selectedJournals.length === 0 || !selectedYears) {
      return { total, amountDetails }
    }
    const yearsArr = Array.isArray(selectedYears) ? selectedYears : [selectedYears]

    selectedJournals.forEach(journalId => {
      const journalSubs = subscriptionData[journalId] || []
      yearsArr.forEach(year => {

        const sub = journalSubs.find(s => s.year === year)
        if (sub) {
          let copies = parseInt(copiesCount, 10)
          if (isNaN(copies) || copies <= 0) {
            copies = 1
          }
          const totalForSub = sub.priceInInr * copies
          total += totalForSub
          amountDetails.push({
            journalId,
            year,
            priceInInr: sub.priceInInr
          })
        }
      })
    })

    console.log(total, amountDetails, 'total, amountDetails')
    return { total, amountDetails }
  }
  loadJournalList = async () => {
    const { dispatch, form } = this.props
    let { data } = await JournalList()
    this.setState({ journalListArr: data })
    form.setFieldsValue({ enterDate: moment() })
  }
  journalAjax = async () => {
    let { dispatch } = this.props
    let { data } = await dispatch(journalsAjaxList())
    this.setState({ journalList: data })
  }
  apiGroupedSubscription = async () => {
    let result = await getGroupedSubscription()
    // console.log(result)
    this.setState({
      subscriptionData: result.data
    })
  }

  chooseDocument = e => {
    let { name, files } = e.target
    if (files && files.length) {
      this.setState({ [name]: files[0] })
    }

  }

  render() {
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
      loading
    } = this.props
    const { edit, journalListArr, lastArticleNo, subscriptionData } = this.state

    console.log(subscriptionData, 'journalListjournalListjournalList')
    console.log(journalListArr, 'journalListArr')

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      }
    }

    const inputSchma = {
      fields: [
        {
          label: 'Name',
          key: 'name',
          required: true,
          placeholder: 'Name'
        },
        {
          label: 'Email',
          key: 'email',
          required: true,
          placeholder: 'email'
        },
        {
          label: 'Mobile',
          key: 'mobile',
          required: true,
          placeholder: 'Mobile'
        },
        {
          label: 'Address',
          key: 'address',
          required: true,
          placeholder: 'Address'
        },
        {
          label: 'Pincode',
          key: 'pincode',
          required: true,
          placeholder: 'pincode'
        },

        {
          label: 'Country',
          key: 'country',
          required: true,
          showSearch: true,
          options: Countries,
          keyAccessor: x => x.name,
          valueAccessor: x => x.name,
          placeholder: 'Country',
          type: 'select',
          onChange: val => {
            setFieldsValue({ country: val })
            console.log('contry Click')

          }
        },
        {
          label: 'State',
          key: 'state',
          required: true,
          placeholder: 'State'
        },
        {
          label: 'City',
          key: 'city',
          required: true,
          placeholder: 'City'
        },
        {
          label: 'Page Number',
          key: 'pageNumber',
          required: true,
          placeholder: 'pageNumber'
        },
        {
          label: 'Contact Person',
          key: 'contactPerson',
          required: true,
          placeholder: 'Contact Person'
        },
        {
          label: 'Designation',
          key: 'designation',
          required: true,
          placeholder: 'Designation'
        },
        {
          label: 'Agency Name',
          key: 'agencyName',
          required: true,
          placeholder: 'Agency Name'
        },
        {
          label: 'End User Address',
          key: 'endUserAddress',
          placeholder: 'End User Address'
        },

        {
          label: 'Subscribe By',
          key: 'subscribeBy',
          required: true,
          type: 'select', options: ['Institute', 'Person'],
          onChange: val => {
            setFieldsValue({ subscribeBy: val })
          }
        },

        {
          label: 'Institute Name',
          key: 'instituteName',
          placeholder: 'Institute Name',
          hidden: !(getFieldValue('subscribeBy') == 'Institute'),
          required: (getFieldValue('subscribeBy') == 'Institute')
        },
        {
          label: 'Institute Contact Person',
          key: 'instituteContactPerson',
          placeholder: 'Institute Contact Person',
          hidden: !(getFieldValue('subscribeBy') == 'Institute'),
          required: (getFieldValue('subscribeBy') == 'Institute')
        },
        {
          label: 'Institute Address',
          key: 'instituteAddress',
          placeholder: 'Institute Address',
          hidden: !(getFieldValue('subscribeBy') == 'Institute'),
          required: (getFieldValue('subscribeBy') == 'Institute')
        },
        {
          label: 'Institute Contact No',
          key: 'instituteContactNo',
          placeholder: 'Institute Contact No',
          hidden: !(getFieldValue('subscribeBy') == 'Institute'),
          required: (getFieldValue('subscribeBy') == 'Institute')
        },
        {
          label: 'Copies',
          key: 'copies',
          required: (getFieldValue('subscribeBy') == 'Institute'),
          type: 'select', options: copiesList,
          onChange: val => {
            setFieldsValue({ copies: val })
          },
          hidden: !(getFieldValue('subscribeBy') == 'Institute')
        },
        {
          label: 'Journal of Interest',
          key: 'journals',
          required: true,
          showSearch: true,
          options: this.state.journalList,
          keyAccessor: x => x._id,
          valueAccessor: x => x.name,
          placeholder: 'Journal',
          type: 'select',
          mode: 'multiple',
          onChange: val => {
            setFieldsValue({ journals: val })
            const selectedJournalId = val && val[0]
            const relatedYears = subscriptionData[selectedJournalId] && subscriptionData[selectedJournalId].map(item => item.year) || []
            this.setState({ yearOptions: relatedYears })

          }

        },
        {
          label: 'Year',
          key: 'year',
          type: 'select',
          options: this.state.yearOptions || [],
          allowClear: true,
          placeholder: 'Year',
          keyAccessor: x => x,

          valueAccessor: x => x,
          onChange: (val) => {
            setFieldsValue({ year: val })
            const selectedJournal = getFieldValue('journals')
            const totalAmount = this.calculateTotalAmount(selectedJournal, val, getFieldValue('copies'))
            this.setState({ totalAmount: totalAmount.total })
            this.setState({ amountDetails: totalAmount.amountDetails })

          }

        }
      ]
      // paymentFields:[
      //   {
      //     label: 'Received Date',
      //     key: 'receivedDate',
      //     required: true,
      //     placeholder: 'Received Date',
      //     type:'date'
      //   },
      //   {
      //     label: 'Mode Of Payment',
      //     key: 'modeOfPayment',
      //     required: true,
      //     placeholder: 'Mode Of Payment',
      //     type: 'select',
      //     options: paymentModeList,
      //     allowClear: true,
      //     keyAccessor: x => x,
      //     valueAccessor: x => x,
      //     onChange: (val) => {
      //       setFieldsValue({ modeOfPayment: val })
      //     }
      //   },
      //   {
      //     label: 'Amount',
      //     key: 'amount',
      //     required: true,
      //     placeholder: 'Amount',
      //   },
      //
      // ]

    }


    return (
      <Drawer
        title={'Add General Subscription'}
        width={'45%'}
        visible={this.props.visible}
        maskClosable={true}
        placement='right'
        onClose={this.props.onClose}>
        <Card bordered={true}>
          <Form
            onSubmit={this.handleSubmit}
            hideRequiredMark
            className={'inputForm'}>

            <Card>
              <Row gutter={16}>
                {inputSchma.fields.map((item, key) => {
                  return (
                    !item.hidden && (
                      <Col
                        span={item.span ? item.span : 12}
                        md={item.span ? item.span : 12}
                        sm={12}
                        xs={24}
                        key={key}>
                        {item.customField ? (
                          item.customField
                        ) : (
                          <GetEachFormFields
                            item={item}
                            getFieldDecorator={getFieldDecorator}
                            formItemLayout={formItemLayout}
                          />
                        )}
                      </Col>
                    )
                  )
                })}
              </Row>

              {this.state && this.state.totalAmount && (
                <>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '16px 0', marginTop: '0px' }}>
                    <div style={{ padding: '12px', background: '#f5f5f5', borderRadius: '4px' }}>

                      <p style={{ margin: 0, fontWeight: 'bold' }}>
                        Total Amount - INR {this.state && this.state.totalAmount}
                      </p>
                    </div>
                  </div>
                </>
              )}
              <Form.Item style={{ marginTop: 32 }}>
                <Button type='primary' htmlType='submit'>
                  SUBMIT
                </Button>
              </Form.Item>
            </Card>
          </Form>


        </Card>
      </Drawer>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(mapStateToProps,
  mapDispatchToProps
)(AddGeneralSubscriptionDrawer)
